import axios from "axios";
import { config } from "../../utils/axiosconfig";
import { base_url } from "../../utils/baseUrl";


const getMous = async () => {
  const response = await axios.get(`${base_url}mou`,config);

  return response.data;
};

const createMous = async (moudata) => {
  const response = await axios.post(`${base_url}mou`, moudata, config);

  return response.data;
};

const updateAMous = async (brand) => {
  const response = await axios.put(
    `${base_url}mou/${brand.id}`,
    { title: brand.brandData.title },
    config
  );

  return response.data;
};
const getAMous = async (id) => {
  const response = await axios.get(`${base_url}mou/${id}`, config);

  return response.data;
};

const deleteAMous = async (id) => {
  const response = await axios.delete(`${base_url}mou/${id}`, config);

  return response.data;
};

const mouService = {
  getMous,
  createMous,
  getAMous,
  updateAMous,
  deleteAMous,
};

export default mouService;
